export default __webpack_public_path__ + "static/media/password-change.0c43e9e8.svg";